// src/pages/foundations.tsx
import React from "react";
import { useVersionContext } from '../context/VersionContext';
import Chip from '@mui/material/Chip';
import { getAvailableFoundations } from "../versions/versionRegistry";  // Add this import

// In src/pages/foundations.tsx
interface FoundationsSidebarProps {
  items?: Array<{ name: string; path: string; deprecated?: string[] }>;  // Add ? for optional
  currentPath?: string;
}

const FoundationsSidebar: React.FC<FoundationsSidebarProps> = ({ items = [], currentPath }) => {  // Default to empty array
  const { currentVersion } = useVersionContext();
  // Use items or compute fallback if empty
  const displayItems = items.length > 0 ? items : getAvailableFoundations(currentVersion.id).map(f => ({
    name: f.name,
    path: f.path,
    deprecated: f.deprecated,
  }));
  
  // Rest of component unchanged
  return (
    <div className="sidebar">
      <h6 className="m-t-10 m-b-0 m-l-20">Foundations</h6>
      <ul id="dynamic-tabs">
        {displayItems.map((item) => (
          <li key={item.path} className={currentPath === `/foundations/${item.path}` ? "active" : ""}>
            <a href={`/foundations/${item.path}`} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px' }}>
              {item.name}
              {item.deprecated?.includes(currentVersion.id) && (
                <Chip label="Deprecated" color="warning" size="small" />
              )}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};


export default FoundationsSidebar;
